import { createContext } from 'react';
import { TenantConfig } from 'types';

export const DeactivateTenantModalContext = createContext<{ open: (tenant: TenantConfig) => void }>({ open: () => {} });
